var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54154 5.54161H5.79154M5.54154 5.79161H5.79154M10.2082 5.54161H10.4582M10.2082 5.79161H10.4582M4.66663 9.99996C4.9444 10.6666 5.99996 12 7.99996 12C9.99996 12 11.0555 10.6666 11.3333 9.99996M5.99996 5.66663C5.99996 5.85072 5.85072 5.99996 5.66663 5.99996C5.48253 5.99996 5.33329 5.85072 5.33329 5.66663C5.33329 5.48253 5.48253 5.33329 5.66663 5.33329C5.85072 5.33329 5.99996 5.48253 5.99996 5.66663ZM10.6666 5.66663C10.6666 5.85072 10.5174 5.99996 10.3333 5.99996C10.1492 5.99996 9.99996 5.85072 9.99996 5.66663C9.99996 5.48253 10.1492 5.33329 10.3333 5.33329C10.5174 5.33329 10.6666 5.48253 10.6666 5.66663ZM15.3333 7.99996C15.3333 12.05 12.05 15.3333 7.99996 15.3333C3.94987 15.3333 0.666626 12.05 0.666626 7.99996C0.666626 3.94987 3.94987 0.666626 7.99996 0.666626C12.05 0.666626 15.3333 3.94987 15.3333 7.99996Z",
    stroke: "#4D4A4F",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileEmoji);
export default __webpack_public_path__ + "static/media/smile_emoji.b0bcf6b36171056ffd1753e504981b16.svg";
export { ForwardRef as ReactComponent };